import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { Decimal } from 'decimal.js-light';
import { Amount, Unit } from 'uom';

export type RenderTemperatureProps = {
    sourceUnit: Unit.Unit<'Temperature'>;
    targetUnit: Unit.Unit<'Temperature'>;
    label: number;
}

export const RenderTemperature = ({ label, sourceUnit, targetUnit }: RenderTemperatureProps) => {
    try {
        const value = Amount.valueAs(
            targetUnit,
            Amount.create(new Decimal(label).toNumber(), sourceUnit),
        ).toFixed(0);
        return (
            <>
                {value} <I18n messageId={targetUnit.name}/>
            </>
        );
    } catch {
        return '-';
    }
};
